module.exports = __webpack_public_path__ + "img/mathias.ee7fa0c7.png";